<div
  *ngIf="!connection || (!socketConnection && isDeviceMounted)"
  class="connection-banner"
  [class.--show]="!connection || (!socketConnection && isDeviceMounted)"
>
  <p class="connection-banner__text">
    {{ connection && !socketConnection ? translate._("NO_SOCKET_CONNECTION") : translate._("NO_CONNECTION") }}
  </p>
  <button class="connection-banner__button" *ngIf="connection && !socketConnection" (tap)="reconnect()">
    {{ loading ? translate._("RECONNECTING") : translate._("RECONNECT") }}
    <i-refresh-ccw class="connection-banner__button__icon" [class.--loading]="loading"></i-refresh-ccw>
  </button>
</div>
